import { motion } from 'framer-motion';

const ContactHero = () => {
  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left - Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-[#1A2F4A] text-white rounded-3xl p-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-8">Get In Touch</h1>

            {/* Contact Details */}
            <div className="space-y-6 mb-12">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <div>
                  <p className="text-white/70 text-sm mb-1">Phone</p>
                  <a href="tel:01943123456" className="text-xl font-semibold hover:text-white/80 transition-colors">
                    01943 123 456
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <div>
                  <p className="text-white/70 text-sm mb-1">Email</p>
                  <a href="mailto:info@wharfedaleplumbing.co.uk" className="text-xl font-semibold hover:text-white/80 transition-colors break-all">
                    info@wharfedaleplumbing.co.uk
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl"></i>
                </div>
                <div>
                  <p className="text-white/70 text-sm mb-1">Address</p>
                  <p className="text-xl font-semibold">
                    Otley, West Yorkshire<br />LS21 3AA
                  </p>
                </div>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="border-t border-white/20 pt-8 mb-8">
              <h3 className="text-xl font-bold mb-4">Opening Hours</h3>
              <div className="space-y-2 text-white/90">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span className="font-semibold">8:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span className="font-semibold">9:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span className="font-semibold">Emergency Only</span>
                </div>
                <div className="mt-4 bg-white/10 rounded-lg p-3 text-center">
                  <span className="font-semibold">24/7 Emergency Callouts Available</span>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h3 className="text-xl font-bold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
              </div>
            </div>
          </motion.div>

          {/* Right - Map */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="rounded-3xl overflow-hidden h-full min-h-[500px]"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18676.54327631869!2d-1.6992474!3d53.9058956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487be5b8e3b6c5a5%3A0x7b9c5b8e3b6c5a5!2sOtley%2C%20West%20Yorkshire!5e0!3m2!1sen!2suk!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Wharfedale Plumbing & Heating Location"
            ></iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;